import { render, staticRenderFns } from "./CompraDetalhesAdmin.vue?vue&type=template&id=420106a9"
import script from "./CompraDetalhesAdmin.vue?vue&type=script&lang=js"
export * from "./CompraDetalhesAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports